import { popularCoursesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const popularCoursesRouteMetadata: IRouteMetadataObj<
  typeof popularCoursesRoutesObj
> = {
  list: {
    title: "popularCourses.index.title",
    description: "popularCourses.index.description",
    lazy: () => import("@/pages/popularCourses/table/page"),
    mode: "index",
    type: "main",
    icon: "HeartLine",
    breadcrumbs: [],
    permission,
  },
};

export const popularCoursesRoutes = createRoute<typeof popularCoursesRoutesObj>(
  popularCoursesRoutesObj,
  popularCoursesRouteMetadata,
);
